/* LUCRÜ™ — © 2026 LUCRÜ. All rights reserved. */
import { motion } from "framer-motion";

const AgentVisualizer = ({ active, enabled }) => {
  const bars = 24;
  return (
    <div className="flex items-center justify-center gap-1.5 h-32" aria-hidden="true" data-testid="agent-visualizer">
      {Array.from({ length: bars }).map((_, i) => {
        const base = 10 + ((i * 37) % 50);
        if (!active) {
          return (
            <div
              key={i}
              className="viz-bar"
              style={{
                height: enabled ? base * 0.6 : 6,
                opacity: enabled ? 0.5 : 0.25,
                transition: "height 0.4s ease, opacity 0.4s ease",
              }}
            />
          );
        }
        return (
          <motion.div
            key={i}
            className="viz-bar"
            animate={{
              height: [base, base + 40 + Math.random() * 20, base],
            }}
            transition={{
              duration: 0.4 + (i % 5) * 0.08,
              repeat: Infinity,
              ease: "easeInOut",
              delay: i * 0.02,
            }}
            style={{ height: base }}
          />
        );
      })}
    </div>
  );
};

export default AgentVisualizer;
